'use es6';

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
export const useActiveAnalyticsPage = () => {
  const [activePage, setActivePage] = useState(null);
  const {
    templateId,
    collectionId,
    categoryId
  } = useParams();
  useEffect(() => {
    // order matters:
    // if templateId exists, it's always a report page
    // if categoryId exists, it's always a category home page
    // if collectionId exists without any template or category, it's a top level home page
    setActivePage(templateId || categoryId || collectionId);
  }, [templateId, collectionId, categoryId]);
  return activePage;
};